import EyeDrawSection from '../EyeDrawSection';
import thumb24 from '../images/thumb_24.jpg';
import thumb25 from '../images/thumb_25.jpg';
import img24 from '../images/24.png';
import img25 from '../images/25.png';

const cards = [
    { title: 'Vitreous - Detachment 1', thumb: thumb24, image: img24 },
    { title: 'Vitreous - Detachment 2', thumb: thumb25, image: img25 },
];

export default function Vitreous() {
    return <EyeDrawSection id="vitreous" title="Vitreous" icon="bi-droplet" cards={cards} />;
}
